import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import PlanFormLayout from './PlanFormLayout';

const PlanForm = ({ initialData, onSubmit, onCancel, buttonText = 'Submit', isEdit = false }) => {
  const [formData, setFormData] = useState({});
  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  const updateFormData = (newData) => {
    setFormData((prev) => ({
      ...newData,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { tiers } = formData;
    if (tiers && tiers.length > 0) {
      for (let i = 0; i < tiers.length; i++) {
        const { starting_from, up_to } = tiers[i];

        if (up_to < starting_from) {
          ({ open: true, type: 'error', message: `Tier ${i + 1} has Overlapping Tier.` });
          return;
        }
      }
    }

    const payload = {
      ...formData,
    };
    onSubmit(payload);
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <PlanFormLayout formData={formData} updateFormData={updateFormData} isEdit={isEdit} />
        <Box
          sx={{
            float: 'right',
            mt: 2,
            right: 0,
          }}
        >
          <Button variant="outlined" color="info" sx={{ mr: 2 }} onClick={onCancel}>
            Cancel
          </Button>

          <Button type="submit" variant="contained" color="primary">
            {buttonText}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default PlanForm;
